import { useModal } from "@/hooks/modals/useModal";
import { usePurchaseRequestDetail } from "./usePurchaseRequest";
import { useFlowNodeMatcher } from "./useFlowNodeMatcher";

export function useFormEditable() {
  const { props } = useModal("PURCHASE_REQUEST");
  const { mode, viewStatus, isReadOnly, recordId } = props;

  const detail = usePurchaseRequestDetail(recordId);

  const isInReviewMode = mode === "inReview";
  const isStartedMode = mode === "started";

  const {
    isMatchFillInPONode,
    isMatchPurchasingStaffFillInNodeForHighOrLow,
    isMatchPurchaseManagerAuditNodeForLow,
    isMatchFinancialFirstAuditNode,
    isMatchUploadContractNode,
    isMatchCreateFixedAssetsNoNode,
    isMatchApplicantAddOrUpdateFilesNodeForHigh,
    isMatchPurchaserAddOrUpdateFilesNodeForHigh,
  } = useFlowNodeMatcher(detail?.insId);

  // 满足下面条件时，主表单禁止编辑
  const mainFormDisabledRules = [isStartedMode && isReadOnly, isInReviewMode];

  // 满足下面条件时，PO表单禁止编辑
  const poFormDisabledRules = [
    isStartedMode,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchFillInPONode !== true,
  ];

  // 满足下面条件时，采购节点对应的寻源结果字段禁止编辑
  const purchasingStaffFormFieldsDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchPurchasingStaffFillInNodeForHighOrLow !== true,
  ];

  // 满足下面条件时，“采购经理审核”对应的寻源结果字段禁止编辑
  const purchaseManagerAuditFormFieldsDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchPurchaseManagerAuditNodeForLow !== true,
  ];

  // 满足下面条件时，"财务人员初审"节点对应的表单字段禁止编辑
  const financialFirstAuditFormFieldsDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchFinancialFirstAuditNode !== true,
  ];

  // 满足下面条件时，"上传合同"节点对应的表单字段禁止编辑
  const uploadContractFormFieldsDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchUploadContractNode !== true,
  ];

  // 满足下面条件时，“财务创建固定资产编号”节点对应的表单节点禁止编辑
  const createFixedAssetsNoFormFieldsDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchCreateFixedAssetsNoNode !== true,
  ];

  // 满足下面条件时，“申请人补充/更新文件”节点对应的表单节点禁止编辑
  const applicantAddOrUpdateFilesFormFieldsForHighDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchApplicantAddOrUpdateFilesNodeForHigh !== true,
  ];

  // 满足下面条件时，“采购补充/更新文件”节点对应的表单节点禁止编辑
  const purchaserAddOrUpdateFilesFormFieldsForHighDisabledRules = [
    isStartedMode && isReadOnly,
    isInReviewMode && viewStatus !== true,
    isInReviewMode && isMatchPurchaserAddOrUpdateFilesNodeForHigh !== true,
  ];

  return {
    isMainFormDisabled: mainFormDisabledRules.some((rule) => !!rule),
    isPOFormDisabled: poFormDisabledRules.some((rule) => !!rule),
    isPurchasingStaffFormFieldsDisabled:
      purchasingStaffFormFieldsDisabledRules.some((rule) => !!rule),
    isPurchaseManagerAuditFormFieldsDisabled:
      purchaseManagerAuditFormFieldsDisabledRules.some((rule) => !!rule),
    isFinancialFirstAuditFormFieldsDisabled:
      financialFirstAuditFormFieldsDisabledRules.some((rule) => !!rule),
    isUploadContractFormFieldsDisabled:
      uploadContractFormFieldsDisabledRules.some((rule) => !!rule),
    isCreateFixedAssetsNoFormFieldsDisabled:
      createFixedAssetsNoFormFieldsDisabledRules.some((rule) => !!rule),
    isApplicantAddOrUpdateFilesFormFieldsForHighDisabled:
      applicantAddOrUpdateFilesFormFieldsForHighDisabledRules.some(
        (rule) => !!rule,
      ),
    isPurchaserAddOrUpdateFilesFormFieldsForHighDisabled:
      purchaserAddOrUpdateFilesFormFieldsForHighDisabledRules.some(
        (rule) => !!rule,
      ),
  };
}
